<template>
    <div id="selectLang" :style="{
                    background: 'linear-gradient(0deg, var(--background-color-first), var(--background-color-second))',
                    color: 'white',
                }">
        <div class="select-lang-container">
            <div class="header">
                <Input
                    inputType="text"
                    placeHolder="Search Language"
                    @v-model="(e) => (searchValue = e)"
                    :value="searchValue"
                    firstIcon="Search"
                />
            </div>
            <div>
                <WebList
                    :listValue="languages"
                    :showKey="'originalName'"
                    :secondaryKey="'label'"
                    :show-flag="true"
                    :searchValue="searchValue"
                    @itemClicked="(lang) => languageSelectHandler(lang)"
                    :defaultSelected="languages.find((lang)=> lang.code == $i18n.locale)"
                />
            </div>
        </div>
    </div>
</template>
<script>
import WebList from "../../common/WebList.vue";
import languages from "../../language/languages.json";
import { sendSocketMessage } from "../../utils/socketStream";
import { getPersistenceData } from "../../utils/persistenceStorage";
import Input from "../../common/Input.vue";
import { mapMutations, mapState } from "vuex";
import * as _ from "lodash";

export default {
    components: { WebList, Input },
    name: "SelectLanguage",
    props: [],
    data() {
        return {
            languages,
            searchValue: null,
        };
    },
    methods: {
        ...mapMutations({
            changePageIndex: "app/CHANGE_PAGE",
            goPrevPage: "app/GO_PREV_PAGE"
        }),
        languageSelectHandler(lang) {
            this.$i18n.locale = lang.code || "tr";
            sendSocketMessage("visitor lang-change", {
                visitorId: this.visitorId,
                siteId: this.site._id,
                preferredLang: lang.code || this.$i18n.locale,
                conversationId: getPersistenceData("conversationId"),
            });
            this.goPrevPage();
        },
    },
    computed: {
        ...mapState({
            visitorId: (state) => state.chat.visitorId,
            site: (state) => state.site.site,
            lastPageIndex: (state) => state.app.lastPageIndex,
            settings: (state) => state.setting.settings,
            backgroundColorFirst: state => _.get(state, 'setting.settings.chatCustomizationSettings.versionV2Theme.colors.backgroundColorFirst', '#fff'),
            backgroundColorSecond: state => _.get(state, 'setting.settings.chatCustomizationSettings.versionV2Theme.colors.backgroundColorSecond', '#fff'),
        }),
    },
    watch: {},
    mounted() {},
    beforeDestroy() {
    },
};
</script>
<style lang="scss">
#selectLang {
    .select-lang-container {
        width: 100%;

        .header {
            display: flex;
            justify-content: center;
            // Arama alani daha genis ve ferah
            padding: 4px 16px 0;
            margin-bottom: 14px;

            input {
                width: 100%;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/V2/SelectLanguage.vue